import { combineReducers } from 'redux';

import Common from './common/reducers';

export default combineReducers({
    Common,
});
